import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Question } from '../../models/underwriter.model';
import { SidesheetComponent } from '../../components/sidesheet/sidesheet.component';

@Component({
    selector: 'app-question-uw-modal',
    templateUrl: './question-uw-modal.component.html',
    styleUrls: ['./question-uw-modal.component.scss'],
    standalone: false
})
export class QuestionUwModalComponent implements OnInit, OnChanges {

  @ViewChild('uwSidesheet') uwSidesheet: SidesheetComponent;

  @Input() question: Question;
  @Input() readOnly = false;
  @Output() questionAnswer = new EventEmitter<Question>();

  quotePageData: any;
  pageInfo: any;
  productSelected: any;
  selectedUwItem: any;

  constructor() {}

  ngOnInit(): void {
    const rawData = sessionStorage.getItem('quotePageData');
    this.productSelected = sessionStorage.getItem('selectedProduct') ? JSON.parse(sessionStorage.getItem('selectedProduct')) : null;
    this.productSelected.uw_collation = this.productSelected?.uw_collation ? JSON.parse(this.productSelected.uw_collation) : null;  
    if (rawData) {
      const allData: any[][] = JSON.parse(rawData);
      // allData.forEach(dataset => {
      //   dataset?.forEach((item: any) => {
      //     if (item?.uw_collation && typeof item.uw_collation === 'string') {
      //       try { item.uw_collation = JSON.parse(item.uw_collation); } catch {}
      //     }
      //   });
      // });

       this.quotePageData = allData[1];
       this.pageInfo = this.quotePageData?.find((item: any) => item.entry_type === 'overview');
      //this.productSelected = [].concat(...allData).find((p: any) => p.product_id === 10);
      console.log(this.productSelected);
      let html = this.productSelected?.uw_collation?.sub_header +'<br><br><strong>'+this.productSelected?.uw_collation?.text+'</strong>';
      $('#sub-header').html(html).removeClass('d-none');
    }
  }

  openSidesheet(uwItem: any): void {
    this.selectedUwItem = uwItem;
    this.uwSidesheet.open();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes.question.currentValue;
    }
  }
}
